/* eslint-disable import/first */
import React, { useContext } from 'react';
import { useNavigate, useLocation } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Typography,
  Checkbox,
} from '@material-ui/core';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { MobileNumberInput } from '../../containers/Profile/MobileNumberInput';
import classnames from 'classnames';
import { Context } from '../../components/Multi-lang/Wrapper';
import { localizePath } from 'spwa-ui-library/esm/utils/helper';
import { createMuiTheme, jssPreset, ThemeProvider, StylesProvider } from '@material-ui/core/styles';
import { create } from 'jss';
// import { selectCountryValidations } = Slices.configSlice;
// import { selectCurrentCountry, isMultiCountry } = Slices.profileSlice;
import loginIcon from './images/login.svg';
import rtl from 'jss-rtl';
import css from './index.module.scss';
const { selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry, isMultiCountry } = Slices.profileSlice;
const CreateProfile = ({
  name,
  handleNameInput,
  nameError,
  isDesktop,
  phnNo,
  handlePhoneInput,
  email,
  emailError,
  handleEmailInput,
  handleCreateProfile,
  phoneError,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  const { oldLocation } = location.state || {};
  const context = useContext(Context);

  const ltrTheme = createMuiTheme({ direction: 'ltr' });
  const rtlTheme = createMuiTheme({ direction: 'rtl' });
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const [isRtl] = React.useState(intl.locale === 'ar' ? rtlTheme : ltrTheme);
  const countryName = useSelector(selectCurrentCountry);
  const getLocalizeURL = (target) => {
    return localizePath(target, context.locale);
  };
  const navigateTo = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const [validateError, setValidateError] = React.useState(true);
  // const [setPhoneError, setValidateError] = React.useState(false);
  const handleLogin = () => {
    navigate(`/${context.locale}/login`, {
      replace: true,
      state: {
        retUrl: '/checkout',
        oldLocation: oldLocation || location,
      },
    });
  };
  React.useEffect(() => {
    if (nameError || emailError || email === '' || name === '' || phnNo === '') {
      setValidateError(true);
    } else {
      if (phnNo.length !== countryValidations?.phnLength) {
        setValidateError(true);
      } else {
        setValidateError(false);
      }
    }
  }, [nameError, emailError, phnNo, email, name, countryValidations.phnLength]);

  return (
    <Grid className={css.root} container spacing={3} justify="center">
      {!isDesktop && (
        <Grid className={css.headerText}>
          <FormattedMessage
            id="createprofile_enterdetails"
            defaultMessage="Please enter your Details"
          />
        </Grid>
      )}

      <Grid>
        <Card className={css.profileCard}>
          <CardContent>
            <Grid container>
              <Grid item>
                <div className={css.loginContainer}>
                  <div className={css.checkOut}>
                    <img src={loginIcon} alt="login icon" />
                    <FormattedMessage
                      id="guest_logincheckout"
                      defaultMessage="Login For Faster Checkout"
                    />
                  </div>
                  <div className={css.buttonLogin}>
                    <Button onClick={handleLogin}>
                      <FormattedMessage id="guest_login" defaultMessage="Login" />
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={3} justify="center">
              <div className={css.center}>
                <FormattedMessage id="guest_or" defaultMessage="OR" />
              </div>
            </Grid>
            <StylesProvider jss={jss}>
              <ThemeProvider theme={isRtl}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      label={<FormattedMessage id="nameCaps" defaultMessage="NAME" />}
                      className={css.nameField}
                      required
                      error={nameError}
                      fullWidth
                      value={name}
                      onChange={handleNameInput}
                      helperText={nameError && intl.formatMessage({ id: 'name_validate' })}
                      inputProps={{ maxLength: 40 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label={<FormattedMessage id="emailUpper" defaultMessage="EMAIL" />}
                      className={css.emailField}
                      required
                      error={emailError}
                      helperText={emailError && intl.formatMessage({ id: 'email_validate' })}
                      fullWidth
                      value={email}
                      type="email"
                      onChange={handleEmailInput}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MobileNumberInput
                      showCountryDropDown={true}
                      countryCode={countryValidations?.defaultCCode}
                      value={phnNo}
                      onChange={handlePhoneInput}
                      page="guest"
                      placeholder
                      maxLength={countryValidations?.phnLength}
                      phoneError={phoneError}
                    />
                  </Grid>
                </Grid>
              </ThemeProvider>
            </StylesProvider>
          </CardContent>
          <div className={css.logMeInSection}>
            <div>
              <Grid item xs={12} className={css.gridLayout}>
                <Checkbox defaultChecked color="primary" edge="end" />
                <div className={css.logMeInText}>Log me in</div>
              </Grid>
            </div>
            <a
              href={getLocalizeURL('terms')}
              className={css.termsConditionText}
              onClick={navigateTo(getLocalizeURL('terms'))}
            >
              <FormattedMessage id="t&c" defaultMessage="T&C" />
            </a>
          </div>
          <CardActions className={classnames(css.actionRow)}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              onClick={handleCreateProfile}
              disabled={validateError}
            >
              <FormattedMessage id="guest_save" defaultMessage="Save" />
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CreateProfile;
